module.exports = __webpack_public_path__ + "img/clubcard-gold.3f87242e.svg";